import { chain, isNil, sortBy } from 'lodash';
import { Component, ChangeDetectorRef, ChangeDetectionStrategy, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { LabTestResult, LabResultsSortInfo } from '../lab-test-results';
import { FilterGridColDef } from '../covance-filter';
import { GridLegendItem } from '../legend';
import { LabTestSortArgs } from '../lab-test-results';
import { LabTestsGridColumnsBuilder } from './lab-tests-grid-columns-builder';
import { createLegend } from '../on-screen-results';
import { TermsStorage } from '../corporate/terms-storage';
import { SUBJECT_LAB_TESTS_DATA_SOURCE, SubjectLabTestsDataSource } from './subject-lab-tests-data-source';
import { GridOptions } from 'ag-grid-community';

@Component({
    selector: 'lab-tests',
    template: require('./lab-tests-grid.component.html'),
    styles: [require('./lab-tests-grid.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LabTestsGridColumnsBuilder]
})
export class LabTestsGridComponent {
    public columns: FilterGridColDef[];
    public exportColumns: FilterGridColDef[];
    public uniqueTests: LabTestResult[] = null;
    public exportData: LabTestResult[] = null;
    public legendData: GridLegendItem[];
    public exportGrid: GridOptions = {};
    public visibleGridOptions: GridOptions = {
        groupRowRendererParams: { suppressCount: true },
        onRowDataChanged: function (params) {
            params.columnApi.autoSizeColumn('test');
        },
        onGridSizeChanged: function (params) {
            params.api.sizeColumnsToFit();
            params.columnApi.autoSizeColumn('test');
        }
    };
    public get disclaimer() {
        return this.termsStorage.osrDisclaimerText;
    }

    private subscription: Subscription;

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        labResultsSortInfo: LabResultsSortInfo,
        @Inject(SUBJECT_LAB_TESTS_DATA_SOURCE) selectedSubjectLabResultsStorage: SubjectLabTestsDataSource,
        columnsBuilder: LabTestsGridColumnsBuilder,
        private termsStorage: TermsStorage
    ) {
        this.subscription = selectedSubjectLabResultsStorage.labTestResults
            .subscribe((testData: LabTestResult[]) => {
                this.uniqueTests = null;

                if (testData) {
                    this.uniqueTests = chain(testData)
                        .uniqBy((item: LabTestResult) => item.uniqLabTestIdKey)
                        .sortBy(labResultsSortInfo.subjectLevel.allLevels)
                        .value();
                }


                const buildedResult = columnsBuilder.getColumns(testData);
                const sortExportDataArgs: LabTestSortArgs = ['testGroup', 'testSequence', 'visitColumnKey',
                    (lab: LabTestResult) => {
                        const tempResult = lab.currentResult;
                        if (!isNil(tempResult)) {
                            let seq = tempResult.sequence;
                            const theResult = tempResult.stringResult;
                            if (theResult) {
                                seq = tempResult.sequence;
                            }
                            return seq;
                        } else {
                            return null;
                        }
                    }
                ];

                this.columns = buildedResult.columns;
                this.exportColumns = buildedResult.exportColumns;
                this.exportData = sortBy(testData, sortExportDataArgs);
                this.legendData = createLegend(testData);
                this.changeDetectorRef.markForCheck();
            });
    }


    public onGridQuickFilterChanged(filter: string) {
        if (this.exportGrid) {
            this.exportGrid.quickFilterText = filter;
        }
    }

    public ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}